import { View, Text } from '@react-pdf/renderer'
import HeaderPDFDefault from '../HeaderPDFDefault'
import ReportCommentsPrefecturePDF from '../ReportCommentsPrefecturePDF'

export default function CommentsPrefecturePDF({
    metadata,
    data,
    title,
    campus,
    startDate,
    endDate,
    teacherKey = "",
    ciclo = "",
    escuela = "",
    direccion = "",
    prefectura = false,
    director,
    tipoIncidencias = ""
}) {
    return (
        <View>
            <HeaderPDFDefault title={title} />
            <ReportCommentsPrefecturePDF
                metadata={metadata}
                data={data}
                campus={campus}
                startDate={startDate}
                endDate={endDate}
                teacherKey={teacherKey}
                ciclo={ciclo}
                escuela={escuela}
                direccion={direccion}
                prefectura={prefectura}
                director={director}
                tipoIncidencias={tipoIncidencias}
            />
            <View style={{ flexDirection: 'row', width: '100%', marginTop: 10, justifyContent: "flex-end" }}>
                <Text style={{ fontSize: 10, }}>Total General: {data.length}</Text>
            </View>
            <View
                fixed
                style={{
                    height: 50,
                    position: 'absolute',
                    bottom: 30,
                    left: 0,
                    right: 0,
                    top: 520
                }}
            >
                <View
                    style={{
                        flexDirection: 'row',
                        justifyContent: 'flex-end'
                    }}
                >
                    <View>
                        <Text
                            style={{
                                color: 'gray',
                                fontSize: 11,
                            }}
                            render={({ pageNumber, totalPages }) => `Page ${pageNumber} of ${totalPages}`}
                        />
                    </View>
                </View>
            </View>
        </View>
    )
}